import { Box } from '@ltvco/refresh-lib/theme';
import { Route, Routes } from 'react-router-dom';

import { DeepSearchProvider } from '../context';

import { DeepSearchPage } from './DeepSearchPage';

export const DeepSearchContainer = () => (
  <Box sx={{ height: '100%', width: '100%' }}>
    <DeepSearchProvider>
      <Routes>
        <Route path="/*" element={<DeepSearchPage />} />
      </Routes>
    </DeepSearchProvider>
  </Box>
);
